import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  VStack,
  Heading,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Card,
  CardHeader,
  CardBody,
  Icon,
  CardFooter,
  Divider,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import {
  FiFileText,
} from 'react-icons/fi';
import { useFormik } from 'formik';
import * as yup from 'yup';

import { Fetch } from 'utils/fetch';
import { useToast } from 'utils/toast';
import { Layout } from 'views/components/layout';
import { Index as Response } from 'interfaces/api/my/index';

const validationSchemas = yup.object({
  title: yup
    .string()
    .required('タイトルを入力してください'),
  url: yup
    .string()
    .required('リンクを入力してください')
});

export const Create = () => {
  const navigate = useNavigate();
  const [response, setResponse] = React.useState<Response | undefined>(undefined);
  const [loading, setLoading] = React.useState<boolean>(true);
  const { sendToast } = useToast();
  const [isConfirm, setIsConfirm] = React.useState<boolean>(false);

  const form = useFormik({
    initialValues: {
      title: '',
      url: ''
    },
    validationSchema: validationSchemas,
    onSubmit: (values: any) => {
      if (!isConfirm) {
        setIsConfirm(true);
        return;
      }

      const seminar = {
        title: values.title,
        url: values.url
      };

      Fetch.post('seminars', seminar).then(res => {
        if (res?.error) {
          sendToast({title: '作成失敗しました', description: '', status: 'error'});
          return false;
        }

        navigate('/seminars');
        return false;
      });
    },
  });

  React.useEffect(() => {
    Fetch.get(`my`).then(res => {
      setLoading(false);

      if (res?.error) {
        return false;
      }

      setResponse(res);
    });
  }, []);

  return (
    <Layout
      currentNavi='seminars'
      loading={loading}
      name={response?.my?.name}
      avatar={response?.my?.avatar}
    >
      <VStack
        w='full'
        h='full'
        p={3}
      >

        <Card
          w='full'
          h='full'
        >
          <form onSubmit={form.handleSubmit} noValidate>
            <CardHeader>
              <Heading size='md'>セミナー新規作成</Heading>
              <Divider mt={3} />
            </CardHeader>
            <CardBody>

              <FormControl
                isRequired
                pb={3}
                isInvalid={form.touched.title && Boolean(form.errors.title)}
              >
                <FormLabel htmlFor='title'>タイトル</FormLabel>
                <Input
                  id='title'
                  name='title'
                  type='text'
                  size='lg'
                  placeholder='タイトル'
                  isRequired
                  onChange={form.handleChange}
                  value={form.values.title}
                  maxLength={50}
                  isDisabled={isConfirm}
                />
                <FormErrorMessage>{String(form.errors.title)}</FormErrorMessage>
              </FormControl>

              <FormControl
                isRequired
                py={5}
                isInvalid={form.touched.url && Boolean(form.errors.url)}
              >
                <FormLabel htmlFor='url'>リンク</FormLabel>
                <Input
                  id='url'
                  name='url'
                  type='url'
                  size='lg'
                  placeholder='リンク'
                  isRequired
                  onChange={form.handleChange}
                  value={form.values.url}
                  maxLength={50}
                  isDisabled={isConfirm}
                />
                <FormErrorMessage>{String(form.errors.url)}</FormErrorMessage>
              </FormControl>
            </CardBody>
            <CardFooter>
              <SimpleGrid
                columns={2}
                spacing={10}
                w='full'
              >
                {!isConfirm ?
                  <>
                  <Button
                    as={Link}
                    to='/seminars'
                  >
                    キャンセル
                  </Button>
                  <Button
                    colorScheme='blue'
                    type='submit'
                  >
                    確認する
                  </Button>
                  </>
                :
                  <>
                  <Button
                    onClick={() => setIsConfirm(false)}
                  >
                    キャンセル
                  </Button>
                  <Button
                    colorScheme='base'
                    type='submit'
                  >
                    作成する
                  </Button>
                  </>
                }
              </SimpleGrid>
            </CardFooter>
          </form>
        </Card>
      </VStack>
    </Layout>
  );
};
